import { render, staticRenderFns } from "./my-feedbacks.vue?vue&type=template&id=6e8288e2"
import script from "./my-feedbacks.vue?vue&type=script&lang=js"
export * from "./my-feedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports